import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-master',
  templateUrl: './user-master.component.html',
  styleUrls: ['./user-master.component.scss']
})
export class UserMasterComponent implements OnInit {
public user:any={};
  constructor(public appservice:AppService,public toastr:ToastrService) { }
  load_Rightslist(){
    this.appservice.getTable("api/Transaction/Get_Rights_List?a="+"a").subscribe({
      next:(res:any)=>{       if(res){
        this.user.rightslist=res;
       }
      },
      error:(err:any)=>{
       this.toastr.error(err,"Error");
      }
    })
  }
  ClearFields(){
    this.user={};
  }
onSubmitUser() {
  this.appservice.postTable("api/Transaction/insert_UserMaster",this.user).subscribe({
    next:(res:any)=>{
     if(res){
      this.toastr.success("Details Saved Successfully","Notification");
        this.ClearFields();
        this.load_Rightslist();
     }
    },
    error:(err:any)=>{
     this.toastr.error(err,"Error");
    }})
  console.log(this.user);
}
Edited_Data(){
  this.load_Rightslist();
  this.appservice.getTable("api/Transaction/Get_User_detailsbyid?id="+this.appservice.usermastereditid).subscribe({
    next:(res:any)=>{
      if(res){
        const a=res;
        this.user=a[0];
      }
    }
  });
}
  ngOnInit(): void {
    this.load_Rightslist();
    if(this.appservice.usermastereditid){
      this.Edited_Data();
    }
  }

}
